import { getPaginated, getApi } from 'util/backendapi/fetch';
import {
  makeReportingDuck,
  ReportingDuckActions,
} from 'ducks/make-reporting-duck';

export const plotSetListDuck = makeReportingDuck(
  'plotSet',
  (filters) => getPaginated('/reports/plot-sets/', filters),
  () => getApi('/reports/plot-sets/info/')
);

export type PlotSetListActions = ReportingDuckActions<typeof plotSetListDuck>;
